import { api } from "./apiClient";
import { PagadorasMap } from "@/types/pagadoras";

export const pagadorasService = {
  get: () => api.get<PagadorasMap>("/pagadoras/"),
  update: (data: PagadorasMap) => api.put<PagadorasMap>("/pagadoras/", data),
};

